import {all, fork, put, take, takeEvery, takeLatest} from "redux-saga/effects";
import {ActionType, getType} from "typesafe-actions";
import {openTile, replaceQuestion, startLevel} from "../actions";
import {loadScene} from "../../routing/actions";
import fetchCategories from "./handleFetchCategories";
import fetchLevelMaps from "./handleFetchLevelMaps";
import handleOpenTile from "./handleOpenTile";
import handleFetchQuestions from "./handleFetchQuestions";
import {AnyAction} from "redux";
import validateLevelMap from "./validateLevelMap";
import preloadLevelMap from "./preloadLevelMap";
import forkWithErrHandler from "../../../shared/utils/forkWithErrHandler";

function* loadLevelDependencies() {
    while (true) {
        yield take((action: AnyAction) => {
            return action.type === getType(loadScene.request)
                && action.payload === "LevelSelection";
        });

        yield all([
            fork(fetchCategories),
            fork(fetchLevelMaps),
        ]);
    }
}

function* loadFreeQuestions() {
    yield takeLatest([getType(startLevel), getType(replaceQuestion)], handleFetchQuestions);
}

function* watchStartLevel() {
    yield takeLatest(getType(startLevel), function* ({ payload } : ActionType<typeof startLevel>) {
        yield put(loadScene.request("LevelMap"));

        yield fork(validateLevelMap, payload.level);
        yield fork(preloadLevelMap, payload.level);
    });
}

function* watchOpenTile() {
    yield takeEvery(getType(openTile), handleOpenTile);
}

export default function* gameSaga() {
    yield all([
        forkWithErrHandler("gameSaga", "loadLevelDependencies", loadLevelDependencies),
        forkWithErrHandler("gameSaga", "loadFreeQuestions", loadFreeQuestions),
        forkWithErrHandler("gameSaga", "watchStartLevel", watchStartLevel),
        forkWithErrHandler("gameSaga", "watchOpenTile", watchOpenTile),
    ]);
}